import React from "react";
import { View, StyleSheet } from "react-native";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";
import NtSectionTitle from "../general/NtSectionTitle";
import NtText from "../../../components/NtText";
import NtSectionDescription from "../general/NtSectionDescription";
import NtMarketingDevider from "../general/NtMarketingDevider";
import NtSectionButton from "../general/NtSectionButton";
import { useMobile } from "../../../hooks/useMobile";

function NtBusinessConnectYourWaySection(props) {
  const isMobile = useMobile();

  const aceFeatures = [
    {
      title: "1 Extension",
    },
    {
      title: "1 Virtual Receptionist",
    },
    {
      title: "1 Local Phone Number",
    },
    {
      title: "Pay-As-You-Go Outbound Minutes",
    },
  ];

  const crewFeatures = [
    {
      title: "5 Extension",
    },
    {
      title: "1 Virtual Receptionist",
    },
    {
      title: "1 Local Phone Number",
    },
    {
      title: "1 (5K) Outbound Minutes Package (5,000 min/mo)",
    },
  ];

  const teamFeatures = [
    {
      title: "10 Extension",
    },
    {
      title: "3 Virtual Receptionist",
    },
    {
      title: "4 Local Phone Number",
    },
    {
      title: "1 Call Queue",
    },
    {
      title: "1 (5K) Outbound Minutes Package (5,000 min/mo)",
    },
  ];

  const renderBox = (containerStyle, title, price, employees, features) => {
    return (
      <View
        style={[
          {
            flex: 1,
            borderRadius: 10,
            backgroundColor: "#181818",
          },
          containerStyle,
        ]}
      >
        <View style={{ padding: 10 }}>
          <NtSectionTitle style={{ fontSize: 16, marginTop: 10 }}>
            {title}
          </NtSectionTitle>
          <NtSectionDescription
            style={{ fontSize: 18, fontWeight: "800", marginTop: 15 }}
          >
            {price}
            <NtText style={{ fontSize: 11, fontWeight: "400" }}>
              {" "}
              / month
            </NtText>
          </NtSectionDescription>

          <NtSectionDescription style={{ fontSize: 11, fontWeight: "300" }}>
            {employees}
          </NtSectionDescription>
        </View>

        <NtMarketingDevider containerStyle={{ marginTop: 15 }} />

        <View>{features?.map((each) => renderRow(each))}</View>

        <View
          style={{
            flex: 1,
            marginTop: 30,
            marginBottom: 15,
            padding: 10,
            justifyContent: "flex-end",
          }}
        >
          <NtSectionButton
            containerStyle={{}}
            title="CUSTOMIZE"
            color="white"
            onPress={() => {
              window.open("https://account.ntconnect.com/site/login");
            }}
          />
        </View>
      </View>
    );
  };

  const renderRow = (item) => {
    return (
      <View key={item.title}>
        <View
          style={{ padding: 15, flexDirection: "row", alignItems: "center" }}
        >
          <View
            style={{
              width: 6,
              height: 6,
              borderRadius: 10,
              backgroundColor: "white",
            }}
          />

          <NtSectionDescription
            style={{
              fontSize: 12,
              fontWeight: "300",
              flex: 1,
              marginLeft: 10,
            }}
          >
            {item.title}
          </NtSectionDescription>
        </View>
        <NtMarketingDevider />
      </View>
    );
  };

  return (
    <NtMarketingSectionContainer style={styles.container}>
      <NtSectionTitle style={{ fontWeight: "300" }}>
        <NtText style={{ fontWeight: "800" }}>CONNECT</NtText> YOUR WAY
      </NtSectionTitle>
      <NtSectionDescription style={{ textAlign: "center", marginTop: 8 }}>
        We offer multiple ways to stay connected with your world.
      </NtSectionDescription>

      <View
        style={{ marginTop: 40, flexDirection: isMobile ? "column" : "row" }}
      >
        {renderBox(
          { marginRight: isMobile ? 0 : 10, marginBottom: isMobile ? 10 : 0 },
          "ACE",
          "$9.97",
          "1 Employee",
          aceFeatures
        )}
        {renderBox(
          { marginRight: isMobile ? 0 : 10, marginBottom: isMobile ? 10 : 0 },
          "CREW",
          "$41.92",
          "5 Employees",
          crewFeatures
        )}
        {renderBox({}, "TEAM", "$92.81", "10 Employees", teamFeatures)}
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingTop: 60,
    paddingBottom: 60,
  },
});

export default NtBusinessConnectYourWaySection;
